// @flow
import actions from "./actions";
import { sleep } from "../../../Utils/AppUtils";

const updateServiceConfigurationsData = actions.updateServiceConfigurationsData;
const setServicePolygon = data => {
    return async (dispatch: Dispatch, getState: GetState) => {
        while (!getState().mapData.ready) {
            await sleep(100);
        }
        return dispatch(actions.setServicePolygon(data));
    };
};
const setOriginTerminalOptions = actions.setOriginTerminalOptions;
const setDestTerminalOptions = actions.setDestTerminalOptions;

export default {
    updateServiceConfigurationsData,
    setServicePolygon,
    setOriginTerminalOptions,
    setDestTerminalOptions,
};


// WEBPACK FOOTER //
// ./src/Store/Ducks/ServiceConfig/operations.js